// this should be store as store for re-exporting the module
import {store as store} from "@stofloos/stores/store";

import app from './reducers/app';
import StofwareProfile from "@stofloos/reducers/profile";
import StofwareAuth from "@stofloos/reducers/auth";
import crud from "@stofloos/reducers/crud";
import toast from "@stofloos/reducers/toast";
import requests from "@stofloos/reducers/requests";
import file from "@stofloos/reducers/file";


store.addReducers({
    app,
    requests,
    StofwareAuth,
    StofwareProfile,
    crud,
    toast,
    file
});

export {store}